export class XApiKeyUtil {
  static readonly X_API_KEYS = {
    dev: '0c11bfd6dc504241be5c7d373d2b70e6',
  };
}
